import styled from 'styled-components'

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryContrast};
  border-radius: 4px;
  font-size: 0.9em;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  /* Center the rehearsal status in the header */
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  
  &:hover {
    background-color: ${({ theme }) => theme.primaryDark || theme.primary};
    opacity: 0.9;
  }

  @media (max-width: 600px) {
    /* Reset centering on mobile */
    position: static;
    transform: none;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    font-size: 0.85em;
    padding: 0.4em 0.8em;
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const StatusLabel = styled.span`
  font-weight: bold;
  margin-right: 0.5em;

  @media (max-width: 600px) {
    margin-right: 0.3em;
  }
`

export const GroupName = styled.span`
  margin-right: 0.5em;

  @media (max-width: 600px) {
    margin-right: 0.3em;
  }
`

export const RoleIndicator = styled.span`
  font-style: italic;
  opacity: 0.9;
`
